import * as React from "react";
const SvgFiRrDebt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-debt_svg__a)">
      <path
        fill="#062147"
        d="m23.95 18.293-1.285-9A5.026 5.026 0 0 0 17.715 5H15.15a3.45 3.45 0 0 0 .351-1.5C15.5 1.57 13.93 0 12 0S8.5 1.57 8.5 3.5c0 .539.133 1.044.351 1.5h-2.49a4.97 4.97 0 0 0-4.945 4.254l-1.359 9A4.997 4.997 0 0 0 5.001 24H19a5.001 5.001 0 0 0 4.95-5.707M10.5 3.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5S12.827 5 12 5s-1.5-.673-1.5-1.5m10.766 17.466A3 3 0 0 1 19 22H5.001a3 3 0 0 1-2.274-1.044 3 3 0 0 1-.692-2.403l1.358-9A2.98 2.98 0 0 1 6.36 7h11.355a3.014 3.014 0 0 1 2.97 2.576l1.284 9a3 3 0 0 1-.703 2.39M12 22a1 1 0 0 1-1-1v-1h-.268a3.01 3.01 0 0 1-2.598-1.499 1 1 0 0 1 1.731-1.002c.18.31.511.501.867.501H13a1 1 0 0 0 1-1 .77.77 0 0 0-.645-.761l-3.04-.506A2.76 2.76 0 0 1 8 13c0-1.654 1.346-3 3-3V9a1 1 0 1 1 2 0v1h.268a3.01 3.01 0 0 1 2.598 1.499 1 1 0 1 1-1.73 1.002A1 1 0 0 0 13.27 12h-2.268c-.55 0-1 .448-1 1a.77.77 0 0 0 .644.761l3.041.506A2.76 2.76 0 0 1 16.001 17c0 1.654-1.346 3-3 3v1a1 1 0 0 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-debt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDebt;
